import { School } from '../school';

const enum Recurrence {
    'MONTHLY',
    'WEEKLY'
}

export class SubscriptionType {
    constructor(
        public id?: number,
        public name?: string,
        public recurrence?: Recurrence,
        public maxAssitancesNum?: number,
        public price?: number,
        public school?: School,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/subscription-type/subscription-type.model.ts